module.exports = __webpack_public_path__ + "img/icons-fill-product-sapphire.535323fa.svg";